import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import styles from './StatsList.scss';

const StatsHeader = ({ heading, amount }) => (
    <div className={styles.total}>
        <span>{heading}</span>
        <span>{amount}</span>
    </div>
);

StatsHeader.propTypes = {
    heading: PropTypes.string.isRequired,
    amount: PropTypes.number.isRequired,
};

const StatsMore = ({ stats, expanded, onToggle }) => {
    const { t } = useTranslation('cards');

    return (
        <>
            {expanded && (
                <ul className={styles.list}>
                    {stats.map((stat) => (
                        <li key={stat.key}>
                            <span>{stat.label}</span>
                            <span>{stat.value}</span>
                        </li>
                    ))}
                </ul>
            )}
            {stats.length > 0 && (
                <span className={classNames(styles.button, { [styles.expanded]: expanded })} onClick={onToggle}>
                    {expanded ? t('statsList.hide') : t('statsList.show')}
                </span>
            )}
        </>
    );
};

StatsMore.propTypes = {
    stats: PropTypes.array.isRequired,
    expanded: PropTypes.bool.isRequired,
    onToggle: PropTypes.func.isRequired,
};

export default class StatsList extends React.Component {
    static propTypes = {
        heading: PropTypes.string,
        stats: PropTypes.oneOfType([PropTypes.array, PropTypes.number]),
    };

    static defaultProps = {
        heading: 'Actions',
        stats: [],
    };

    constructor(props) {
        super(props);

        this.state = {
            expanded: false,
        };
    }

    toggleList = () => {
        this.setState((state) => ({
            expanded: !state.expanded,
        }));
    };

    render() {
        const { heading, stats } = this.props;
        const { expanded } = this.state;
        const isArray = Array.isArray(stats);
        const total = isArray ? stats.reduce((prev, curr) => prev + curr.value, 0) : stats;

        return (
            <div className={styles.root}>
                <StatsHeader heading={heading} amount={total} />
                {isArray && <StatsMore stats={stats} expanded={expanded} onToggle={this.toggleList} />}
            </div>
        );
    }
}
